import gql from 'graphql-tag';
import { RECORDING_PROPS } from "./Component"

export const GET_RECORDING = gql`
  query Recording (
    $personId: ID!, 
    $projectId: ID!, 
    $referenceId: ID!
  ) {
    Recording(
      personId: $personId, 
      projectId: $projectId, 
      referenceId: $referenceId
    ) {
      __typename
      id,
      title,
      subtitle,
      version,
      creationDate {formatted},
      creationDateIsApproximate,
      lastModifiedDate {formatted},
      type,
      proprietaryId,
      proprietaryIdNamespace,
      status,
      url,
      project {
        id,
        title,
        status,
        type,
        owners {
          id,
          fullName,
          __typename
        }
      }
      comments {
        id,
        text,
        creationDate {
          formatted
        }
        lastModifiedDate { formatted },
        author {
          id,
          accountId,
          fullName,
          imageDepictions {
            id,
            title,
            type,
            thumbnail { 
              id, 
              file { 
                uri 
                }
              }
            }
          __typename
        }
      }
      genres {
        id,
        name
      }
      contributions {
        id,
        contributor {
          id,
          fullName,
          __typename
        }
        role,
        isCredited,
        creditText,
        featured
      }
      rightShares {
        id,
        percent,
        territoryCode,
        owners {
          id,
          fullName,
          __typename
        }
        controllers {
          id,
          fullName,
          __typename
        }
        administrators {
          id,
          fullName,
          __typename
        }
        for {
          id,
          role
        }
      }
      file {
        id,
        proprietaryId,
        fileName,
        fileType,
        uri,
        size,
        bitDepth,
        bitRate,
        samplingRate,
        codecType
      }
      versions {
        id,
        title,
        file {
          id,
          proprietaryId,
          fileName,
          fileType,
          uri
        }
      }
      isVersionOf {
        id,
        title,
        file {
          id,
          proprietaryId,
          fileName,
          fileType,
          uri
        }
      }
      mood {
        id,
        name
      }
      equipment {
        id,
        name,
        type
      }
      referrer {
        __typename,
        ...on Project {
          id,
          title,
          status,
          type,
          owners {
            id,
            fullName,
            __typename
          }
        }
      }
      resourceOf {
        __typename,
        ...on Project {
          id,
          title,
          status,
          type,
          owners {
            id,
            fullName,
            __typename
          }
        }
      }
      isrc,
      trmid,
      puid,
      language,
      catalogNumber,
      isInstrumental,
      isMedley,
      sequenceNumber,
      duration,
      masteredDate {formatted},
      firstPublicationDate {formatted},
      firstPublicationDateApplicableTerritoyCode,
      territoryOfFixation,
      keySignature,
      timeSignature,
      tempo,
      numberOfAudioChannels,
      isMultiTrack,
      isStereo,
      previewStartPoint,
      previewDuration,
      previewType,
      work {
        id,
        title
      }
      stems {
        to {
          Recording {
            id,
            title,
            file {
              id,
              proprietaryId,
              fileName,
              fileType,
              uri
            }
            instruments {
              id,
              name,
              type
            }
          }
          startTime
          duration
        }
      }
      stemOf {
        from {
          Recording {
            id,
            title,
            file {
              id,
              proprietaryId,
              fileName,
              fileType,
              uri
            }
          }
          startTime
          duration
        }
      }
      sampledRecordings {
        to {
          Recording {
            id,
            title,
            file {
              id,
              proprietaryId,
              fileName,
              fileType,
              uri
            }
            instruments {
              id,
              name,
              type
            }
          }
          startTime
          duration
        }
      }
      sampledIn {
        from {
          Recording {
            id,
            title,
            file {
              id,
              proprietaryId,
              fileName,
              fileType,
              uri
            }
          }
          startTime
          duration
        }
      }
      instruments {
        id,
        name,
        type
      }
      release {
        id,
        title,
        type
      }
    }
  }
`;

export const CREATE_RECORDING = gql`
  mutation createRecording (
    $id: ID,
    $title: String,
    $subtitle: String,
    $version: String,
    $creationDate: _Neo4jDateTimeInput
    $creationDateIsApproximate: Boolean,
    $lastModifiedDate: _Neo4jDateTimeInput
    $type: String,
    $proprietaryId: String,
    $proprietaryIdNamespace: String,
    $status: String,
    $url: String,
    $isrc: String,
    $trmid: String,
    $puid: String,
    $language: String,
    $catalogNumber: String,
    $isInstrumental: Boolean,
    $isMedley: Boolean,
    $sequenceNumber: Int,
    $duration: Int,
    $masteredDate: _Neo4jDateInput
    $firstPublicationDate: _Neo4jDateInput
    $firstPublicationDateApplicableTerritoyCode: String,
    $territoryOfFixation: String,
    $keySignature: String,
    $timeSignature: String,
    $tempo: Int,
    $numberOfAudioChannels: Int,
    $isMultiTrack: Boolean,
    $isStereo: Boolean,
    $previewStartPoint: Int,
    $previewDuration: Int,
    $previewType: String,
  ) {
    CreateRecording(
      id: $id,
      title: $title,
      subtitle: $subtitle,
      version: $version,
      creationDate: $creationDate,
      creationDateIsApproximate: $creationDateIsApproximate,
      lastModifiedDate: $lastModifiedDate,
      type: $type,
      proprietaryId: $proprietaryId,
      proprietaryIdNamespace: $proprietaryIdNamespace,
      status: $status,
      url: $url,
      isrc: $isrc,
      trmid: $trmid,
      puid: $puid,
      language: $language,
      catalogNumber: $catalogNumber,
      isInstrumental: $isInstrumental,
      isMedley: $isMedley,
      sequenceNumber: $sequenceNumber,
      duration: $duration,
      masteredDate: $masteredDate,
      firstPublicationDate: $firstPublicationDate,
      firstPublicationDateApplicableTerritoyCode: $firstPublicationDateApplicableTerritoyCode,
      territoryOfFixation: $territoryOfFixation,
      keySignature: $keySignature,
      timeSignature: $timeSignature,
      tempo: $tempo,
      numberOfAudioChannels: $numberOfAudioChannels,
      isMultiTrack: $isMultiTrack,
      isStereo: $isStereo,
      previewStartPoint: $previewStartPoint,
      previewDuration: $previewDuration,
      previewType: $previewType
    ) {
        id,
        title,
        subtitle,
        version,
        creationDate {formatted},
        creationDateIsApproximate,
        lastModifiedDate {formatted},
        type,
        proprietaryId,
        proprietaryIdNamespace,
        status,
        url,
        isrc,
        trmid,
        puid,
        language,
        catalogNumber,
        isInstrumental,
        isMedley,
        sequenceNumber,
        duration,
        masteredDate {formatted},
        firstPublicationDate {formatted},
        firstPublicationDateApplicableTerritoyCode,
        territoryOfFixation,
        keySignature,
        timeSignature,
        tempo,
        numberOfAudioChannels,
        isMultiTrack,
        isStereo,
        previewStartPoint,
        previewDuration,
        previewType
    }
  }
`;

export const CREATE_RECORDING_COMPONENT = gql`
mutation createRecordingComponent (
    $partyId: ID!,
    $projectId: ID,
    $componentInput: RecordingInput, 
    $fileInput: FileInput,
    $componentGroup: String,
    $componentGroupOrderWeight: Int, 
    $componentOrderWeight: Int
    $fullFileKey: String!
  ) {
    CreateRecordingComponent(
      partyId: $partyId,
      projectId: $projectId,
      componentInput: $componentInput,
      fileInput: $fileInput
      componentGroup: $componentGroup
      componentGroupOrderWeight: $componentGroupOrderWeight
      componentOrderWeight: $componentOrderWeight
      fullFileKey: $fullFileKey
    ) {

        ${RECORDING_PROPS}
        versions: versionsInProject {
          ...on Recording {
            ${RECORDING_PROPS}
            versions: versionsInProject {
              id
            }
          }
        }
      
    }
  }
`;

export const CREATE_RECORDING_REFERENCE = gql`
mutation createRecordingReference (
    $partyId: ID!,
    $projectId: ID,
    $componentInput: RecordingInput, 
    $fileInput: FileInput,
    $fullFileKey: String!
  ) {
    CreateRecordingReference(
      partyId: $partyId,
      projectId: $projectId,
      componentInput: $componentInput,
      fileInput: $fileInput
      fullFileKey: $fullFileKey
    ) {

        ${RECORDING_PROPS}
        versions: versionsInProject {
          ...on Recording {
            ${RECORDING_PROPS}
            versions: versionsInProject {
              id
            }
          }
        }
      
    }
  }
`;

export const CREATE_VERSION_OF_RECORDING_REFERENCE = gql`
mutation createVersionOfRecordingReference (
    $partyId: ID!,
    $projectId: ID,
    $componentInput: RecordingInput, 
    $fileInput: FileInput,
    $componentGroup: String,
    $componentGroupOrderWeight: Int, 
    $componentOrderWeight: Int
    $parentComponentId: ID!
    $latestVersionComponentId: ID!
    $workId: ID!
    $fullFileKey: String!
  ) {
    CreateVersionOfRecordingReference(
      partyId: $partyId,
      projectId: $projectId,
      componentInput: $componentInput,
      fileInput: $fileInput
      componentGroup: $componentGroup
      componentGroupOrderWeight: $componentGroupOrderWeight
      componentOrderWeight: $componentOrderWeight
      parentComponentId: $parentComponentId
      latestVersionComponentId: $latestVersionComponentId
      workId: $workId
      fullFileKey: $fullFileKey
    ) {
      ${RECORDING_PROPS}
      versions: versionsInProject {
        ...on Recording {
          ${RECORDING_PROPS}
          versions: versionsInProject {
            id
          }
        }
      }
    }
  }
`;

export const CREATE_VERSION_OF_RECORDING_COMPONENT = gql`
mutation createVersionOfRecordingComponent (
    $partyId: ID!,
    $projectId: ID,
    $componentInput: RecordingInput, 
    $fileInput: FileInput,
    $componentGroup: String,
    $componentGroupOrderWeight: Int, 
    $componentOrderWeight: Int
    $parentComponentId: ID!
    $latestVersionComponentId: ID!
    $workId: ID!
    $fullFileKey: String!
  ) {
    CreateVersionOfRecordingComponent(
      partyId: $partyId,
      projectId: $projectId,
      componentInput: $componentInput,
      fileInput: $fileInput
      componentGroup: $componentGroup
      componentGroupOrderWeight: $componentGroupOrderWeight
      componentOrderWeight: $componentOrderWeight
      parentComponentId: $parentComponentId
      latestVersionComponentId: $latestVersionComponentId
      workId: $workId
      fullFileKey: $fullFileKey
    ) {
      ${RECORDING_PROPS}
      versions: versionsInProject {
        ...on Recording {
          ${RECORDING_PROPS}
          versions: versionsInProject {
            id
          }
        }
      }
    }
  }
`;

export const CREATE_RECORDING_WITH_REFERRER = gql`
  mutation createRecordingWithReferrer (
    $personId: ID!,
    $url: String!,
    $projectId: ID!,
  ) {
    CreateRecordingWithReferrer(
      partyId: $personId,
      url: $url,
      projectId: $projectId,
    ) {
        id,
        title,
        subtitle,
        version,
        creationDate {formatted},
        creationDateIsApproximate,
        lastModifiedDate {formatted},
        type,
        proprietaryId,
        proprietaryIdNamespace,
        status,
        url,
        isrc,
        trmid,
        puid,
        language,
        catalogNumber,
        isInstrumental,
        isMedley,
        sequenceNumber,
        duration,
        masteredDate {formatted},
        firstPublicationDate {formatted},
        firstPublicationDateApplicableTerritoyCode,
        territoryOfFixation,
        keySignature,
        timeSignature,
        tempo,
        numberOfAudioChannels,
        isMultiTrack,
        isStereo,
        previewStartPoint,
        previewDuration,
        previewType
    }
  }
`;

export const UPDATE_RECORDING = gql`
  mutation updateRecording (
    $personId: ID!,
    $input: RecordingInput
  ) {
    UpdateRecording(
      personId: $personId,
      input: $input
    ) {
        id,
        title,
        subtitle,
        version,
        creationDate {formatted},
        creationDateIsApproximate,
        lastModifiedDate {formatted},
        type,
        proprietaryId,
        proprietaryIdNamespace,
        status,
        url,
        isrc,
        trmid,
        puid,
        language,
        catalogNumber,
        isInstrumental,
        isMedley,
        sequenceNumber,
        duration,
        masteredDate {formatted},
        firstPublicationDate {formatted},
        firstPublicationDateApplicableTerritoyCode,
        territoryOfFixation,
        keySignature,
        timeSignature,
        tempo,
        numberOfAudioChannels,
        isMultiTrack,
        isStereo,
        previewStartPoint,
        previewDuration,
        previewType
        __typename
    }
  }
`;

export const DELETE_RECORDING = gql`
  mutation deleteRecording (
    $personId: ID!,
    $referenceId: ID!
  ) {
    DeleteRecording(
      personId: $personId,
      referenceId: $referenceId
  ) {
    id
  }
}
`;

export const UPDATE_RECORDING_COMPONENT = gql`
  mutation updateRecordingComponent(
    $input: UpdateComponentInput!
  ) {
    UpdateRecordingComponent(
      input: $input
  ) {
    ${RECORDING_PROPS}
      versions: versionsInProject {
        ...on Recording {
          ${RECORDING_PROPS}
          versions: versionsInProject {
            id
          }
        }
      }
  }
}
`;



export const ADD_RECORDING_STEMS = gql`
  mutation addRecordingStems(
    $from: _RecordingInput!
    $to: _RecordingInput!
    $startTime: Int
    $duration: Int
  ) {
    AddRecordingStems(
      from: $from
      to: $to
      data: {
        startTime: $startTime
        duration: $duration
      }
    ) {
      from {id}
      to {id}
      startTime
   		duration
    }
  }
`;

export const REMOVE_RECORDING_STEMS = gql`
  mutation removeRecordingStems(
    $from: _RecordingInput!
    $to: _RecordingInput!
  ) {
    RemoveRecordingStems(
     from: $from
      to: $to
    ) {
      from {id}
      to {id}
    }
  }
`;

export const ADD_RECORDING_SAMPLED_RECORDINGS = gql`
  mutation addRecordingSampledRecordings(
    $from: _RecordingInput!
    $to: _RecordingInput!
    $startTime: Int
    $duration: Int
  ) {
    AddRecordingSampledRecordings(
      from: $from
      to: $to
      data: {
        startTime: $startTime
        duration: $duration
      }
    ) {
      from {id}
      to {id}
      startTime
   		duration
    }
  }
`;

export const REMOVE_RECORDING_SAMPLED_RECORDINGS = gql`
  mutation removeRecordingSampledRecordings(
    $from: _RecordingInput!
    $to: _RecordingInput!
  ) {
    RemoveRecordingSampledRecordings(
     from: $from
      to: $to
    ) {
      from {id}
      to {id}
    }
  }
`;

export const ADD_RECORDING_REFERRER = gql`
  mutation addRecordingReferrer (
    $from: _ProjectInput!
    $to: _RecordingInput!
  ) {
  AddRecordingReferrer(
    from: $from
    to: $to
  ) {
    from { id }
    to { id }
    }
  }
`;




// AddRecordingProject(
//   from: _ProjectInput!
//   to: _RecordingInput!
// ): _AddRecordingProjectPayload
// RemoveRecordingProject(
//   from: _ProjectInput!
//   to: _RecordingInput!
// ): _RemoveRecordingProjectPayload
// AddRecordingComments(
//   from: _CommentInput!
//   to: _RecordingInput!
// ): _AddRecordingCommentsPayload
// RemoveRecordingComments(
//   from: _CommentInput!
//   to: _RecordingInput!
// ): _RemoveRecordingCommentsPayload
// AddRecordingGenres(
//   from: _GenreInput!
//   to: _RecordingInput!
// ): _AddRecordingGenresPayload
// RemoveRecordingGenres(
//   from: _GenreInput!
//   to: _RecordingInput!
// ): _RemoveRecordingGenresPayload
// AddRecordingContributions(
//   from: _ContributionInput!
//   to: _RecordingInput!
// ): _AddRecordingContributionsPayload
// RemoveRecordingContributions(
//   from: _ContributionInput!
//   to: _RecordingInput!
// ): _RemoveRecordingContributionsPayload
// AddRecordingRightShares(
//   from: _ShareInput!
//   to: _RecordingInput!
// ): _AddRecordingRightSharesPayload
// RemoveRecordingRightShares(
//   from: _ShareInput!
//   to: _RecordingInput!
// ): _RemoveRecordingRightSharesPayload
// AddRecordingFile(
//   from: _RecordingInput!
//   to: _FileInput!
// ): _AddRecordingFilePayload
// RemoveRecordingFile(
//   from: _RecordingInput!
//   to: _FileInput!
// ): _RemoveRecordingFilePayload
// AddRecordingMood(
//   from: _MoodInput!
//   to: _RecordingInput!
// ): _AddRecordingMoodPayload
// RemoveRecordingMood(
//   from: _MoodInput!
//   to: _RecordingInput!
// ): _RemoveRecordingMoodPayload
// AddRecordingEquipment(
//   from: _RecordingInput!
//   to: _EquipmentInput!
// ): _AddRecordingEquipmentPayload
// RemoveRecordingEquipment(
//   from: _RecordingInput!
//   to: _EquipmentInput!
// ): _RemoveRecordingEquipmentPayload
// AddRecordingStems(
//   from: _RecordingInput!
//   to: _RecordingInput!
// ): _AddRecordingStemsPayload
// RemoveRecordingStems(
//   from: _RecordingInput!
//   to: _RecordingInput!
// ): _RemoveRecordingStemsPayload
// AddRecordingStemOf(
//   from: _RecordingInput!
//   to: _RecordingInput!
// ): _AddRecordingStemOfPayload
// RemoveRecordingStemOf(
//   from: _RecordingInput!
//   to: _RecordingInput!
// ): _RemoveRecordingStemOfPayload
// AddRecordingSampledRecordings(
//   from: _RecordingInput!
//   to: _RecordingInput!
// ): _AddRecordingSampledRecordingsPayload
// RemoveRecordingSampledRecordings(
//   from: _RecordingInput!
//   to: _RecordingInput!
// ): _RemoveRecordingSampledRecordingsPayload
// AddRecordingSampledIn(
//   from: _RecordingInput!
//   to: _RecordingInput!
// ): _AddRecordingSampledInPayload
// RemoveRecordingSampledIn(
//   from: _RecordingInput!
//   to: _RecordingInput!
// ): _RemoveRecordingSampledInPayload
// AddRecordingInstruments(
//   from: _RecordingInput!
//   to: _InstrumentInput!
// ): _AddRecordingInstrumentsPayload
// RemoveRecordingInstruments(
//   from: _RecordingInput!
//   to: _InstrumentInput!
// ): _RemoveRecordingInstrumentsPayload
// AddRecordingWork(
//   from: _RecordingInput!
//   to: _WorkInput!
// ): _AddRecordingWorkPayload
// RemoveRecordingWork(
//   from: _RecordingInput!
//   to: _WorkInput!
// ): _RemoveRecordingWorkPayload
// AddRecordingRelease(
//   from: _ReleaseInput!
//   to: _RecordingInput!
// ): _AddRecordingReleasePayload
// RemoveRecordingRelease(
//   from: _ReleaseInput!
//   to: _RecordingInput!
// ): _RemoveRecordingReleasePayload
